import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './MenuTop.css';
export default function MenuTop() {
    function szukajHandle(event) {
        event.preventDefault();
        const data = new FormData(event.target);
        if (window.location.pathname.includes('/katalog/sklepy')) {
            window.location = process.env.PUBLIC_URL + "/katalog/sklepy/" + data.get('str');
        } else {
            window.location = process.env.PUBLIC_URL + "/katalog/szukaj/" + data.get('str');
        }
    }
    return (
        <Nav>
            <Nav.Item>
                <Form onSubmit={szukajHandle} className="form-inline">
                    <Form.Group controlId="formBasicEmail">
                        <Form.Control name="str" className="mt-1 rounded tekst" size="sm" type="text" placeholder="Szukaj produkt..." />
                        <Button variant="primary" size="sm" type="submit" className="rounded mt-1 szukaj-przycisk" >
                            <Image className="szukaj" src="https://pics.freeicons.io/uploads/icons/png/9385963701556258272-512.png" />
                        </Button>
                    </Form.Group>
                </Form>
            </Nav.Item>
            <Nav.Item>
                <Button variant="primary" size="sm" className="rounded ml-4 mt-1" href={process.env.PUBLIC_URL + "/produkt/0"}>
                    Dodaj produkt
                </Button>
            </Nav.Item>
            <Nav.Item>
                <Button variant="primary" size="sm" className="rounded ml-4 mt-1" href={process.env.PUBLIC_URL + "/katalog/sklepy"}>
                    Produkty sklepy
                </Button>
            </Nav.Item>
        </Nav>
    );
}
